import React, { useRef } from 'react'

const Dragdrop = props => {
  // props for this file from parent
  const {
    display,
    senddata,
    displayte,
    sendname,
    sendnamete,
    personnames,
    sendsearchtrue,
    sendtruevalue,
    name,
    editmode,
    editpersonmode,
    sendPersonEditmode,
    modeUrl,
    indication,
  } = props
  // state varible for this file
  const dragItem = useRef()
  const dragOverItem = useRef()
  // function to triger on click for edit mode
  const edit = (event, index) => {
    sendPersonEditmode(false)
    console.log(personnames, 'names')
    sendtruevalue(`${name}_En`, true)
    // if (personnames.some(e => e.label === display[index]) === false) {
    sendsearchtrue(!true)
    console.log(display)
    const copyListItems = [...display]
    console.log(display, 'items')
    const value = copyListItems.splice(index, 1)
    const value1 = value
    sendname(value1)
    const copyListItemste = [...displayte]
    const valuete = copyListItemste.splice(index, 1)
    console.log(value1)
    sendnamete(valuete)
    senddata(copyListItems, copyListItemste)
  }

  const dragStart = (e, position) => {
    // in this function starting postion of  dragged item is calculated
    dragItem.current = position
    console.log(e.target.innerHTML)
  }

  const dragEnter = (e, position) => {
    // in this function ending postion of  dragged item is calculated
    dragOverItem.current = position
    console.log(e.target.innerHTML)
  }

  const drop = () => {
    sendtruevalue(`${name}_En`, true)
    const copyListItems = [...display]
    console.log(display)
    const dragItemContent = copyListItems[dragItem.current]
    copyListItems.splice(dragItem.current, 1)
    copyListItems.splice(dragOverItem.current, 0, dragItemContent)
    console.log(displayte, 'displayte')
    const copyListItemste = [...displayte]
    const dragItemContentte = copyListItemste[dragItem.current]
    copyListItemste.splice(dragItem.current, 1)
    copyListItemste.splice(dragOverItem.current, 0, dragItemContentte)
    dragItem.current = null
    dragOverItem.current = null
    console.log(copyListItemste)
    // new arrays after drag and drop is sent to parent
    senddata(copyListItems, copyListItemste)
  }

  // funtion to trigger when X button is clicked to delete name or value from array
  const deleteFunction = (event, index) => {
    sendtruevalue(`${name}_En`, true)
    // items are spliced based on index
    const copyListItems = [...display]
    copyListItems.splice(index, 1)
    const copyListItemste = [...displayte]
    copyListItemste.splice(index, 1)
    // new arrays after deletion is sent to parent
    senddata(copyListItems, copyListItemste)
  }

  const indicator = modeUrl && indication
  return (
    <div
      style={{ display: 'flex', flexWrap: 'wrap', border: '1px solid lightgray', ...indicator }}
      className='rounded'
    >
      {display &&
        display.map((item, index) => (
          <div
            onDragStart={e => dragStart(e, index)}
            onDragEnter={e => dragEnter(e, index)}
            onDragEnd={drop}
            key={index}
            draggable
          >
            {editmode === 'edit' ? (
              <div
                style={{
                  margin: '5px',
                  border: '1px solid black',
                  padding: '2px',
                  borderRadius: '1rem',
                  maxWidth: '90%',
                  display: 'flex',
                  width: '13.5rem',
                  position: 'relative',
                }}
              >
                <p
                  onClick={event => {
                    if (editpersonmode === true) {
                      edit(event, index)
                    }
                  }}
                  style={{ Width: '100%', fontSize: 'small', overflowWrap: 'anywhere' }}
                >
                  {item}
                </p>
                <div style={{ position: 'absolute', right: '0.5rem' }}>
                  <button
                    type='button'
                    style={{ borderRadius: '1rem' }}
                    onClick={event => deleteFunction(event, index)}
                  >
                    x
                  </button>
                </div>
              </div>
            ) : (
              <div
                style={{
                  margin: '5px',
                  border: '1px solid black',
                  padding: '2px',
                  borderRadius: '1rem',
                  maxWidth: '90%',
                  display: 'flex',
                }}
              >
                <p
                  onClick={event => {
                    if (editpersonmode === true) {
                      edit(event, index)
                    }
                  }}
                >
                  {item}
                </p>
                <div>
                  <button
                    type='button'
                    style={{ borderRadius: '1rem' }}
                    onClick={event => deleteFunction(event, index)}
                  >
                    x
                  </button>
                </div>
              </div>
            )}
          </div>
        ))}
    </div>
  )
}

export default Dragdrop
